import React, { Fragment } from 'react';
import { Button }from '@cmsgov/design-system';

import { FormattedMessage } from 'react-intl';

// Components

import ModalHeader from '@common-components/headers/ModalHeader';

// Constants
import { configs } from '@constants/configs/configs';
import { ConditionalRendering } from '@common-components/conditional-rendering';



const InformMedicareEligibleModal = props => {

    const {
        actions: {
            hideAllModals
        },
        bottomAnchors: [
            anchor_1,
        ],
        boundAnchor,
        environment: {
            isState
        },
        modal: {
            modalData: {
                membersList,
                callbacks
            }
        },
        modalHeaderProps
    } = props;

    const handleHideClick = () => hideAllModals();

    const handleRightBtnClick = () => {
        handleHideClick();
        callbacks.map(callback => {
            callback();
        });
    };

    const getPath = fileName => {
        return configs.ENV.DEVELOPMENT
            ? `../../../../assets/images/nj/${fileName}`        // Copy the image in resources to this path to see locally
            : configs.endpoints.IMAGES.processReplacements({
                relativePath: '/resources/images/nj',
                fileName
            });
    };

    return (
        <Fragment>
            <div className = 'gi-modal__header__head' >
                <ModalHeader
                    { ...{
                        ...modalHeaderProps,
                        hideModal: hideAllModals
                    } }
                    closeAllModals
                    hideAllModals={hideAllModals}
                />
            </div>
            <div
                className = 'gi-modal__body txt-left'
                id = 'informMedicareEligibleModal'
            >
                {
                    membersList && membersList.map((member, i) => {

                        return(
                            <div key = { `${ member }_${ i }` } >
                                <FormattedMessage
                                    id = 'modals.medicare_eligible.probably_medicare'
                                    values = { {
                                        personName: <strong>{ member }</strong>
                                    } }
                                    tagName = 'p'
                                />
                                <FormattedMessage
                                    id = 'modals.medicare_eligible.notice'
                                    tagName = 'p'
                                />
                                <ConditionalRendering isTrue={isState.NJ}>
                                    <div className='grid-col-6 my-3' data-testid='medicare_card_image' >
                                        <img
                                            alt='Sample Medicare Health Insurance card'
                                            src={getPath('medicare_card.png')}
                                            onError={(e) => (e.target.src = '../../../../assets/images/nj_error_illustration.png')} // fallback error image
                                        />
                                    </div>
                                </ConditionalRendering>
                                <a href='https://www.healthcare.gov/medicare/' id={`external__link_to_exchgange_${i}`} target='blank'>
                                    <FormattedMessage id='modals.medicare_eligible.learn_more' />
                                </a>
                            </div>
                        );
                    })
                }   
            </div>
            <div className = 'gi-modal__controls' >
                <Button
                    className = 'usa-button usa-button--outline gi-button gi-button__outline'
                    onClick = { handleHideClick }
                >
                    <FormattedMessage id = 'button.close' />
                </Button>
                <Button
                    className = 'usa-button gi-button gi-button__primary'
                    onClick = { handleRightBtnClick }
                    inputRef = { boundAnchor(anchor_1) }
                >
                    <FormattedMessage id = 'button.ok' />
                </Button>
            </div>
        </Fragment>
    );
};

export default InformMedicareEligibleModal;
